import styled from "styled-components";

// Styled Components
export const Container = styled.div<{ isMobile: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
  padding-top: 8px;
  padding-bottom: ${({ isMobile }) => (isMobile ? `10px;` : `0px`)};
  justify-content: space-between;
`;

export const InputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const NumberInput = styled.input`
  border: none;
  background-color: #f4f4f4;
  border-radius: 0.875rem;
  padding-left: 40px;
  padding-right: 10px;
  font-size: 12px;
  font-weight: 500;
  width: 100%;
  height: 40px;
`;

export const DegreeSymbol = styled.span`
  color: white;
  font-size: 12px;
  margin-left: 4px;
`;

export const DialContainer = styled.div<{ isMobile: boolean }>`
  position: relative;
  width: ${({ isMobile }) => (isMobile ? "54px" : "32px")};
  height: ${({ isMobile }) => (isMobile ? "54px" : "32px")};
  cursor: pointer;
`;

export const DialCircle = styled.div`
  position: absolute;
  inset: 0;
  border-radius: 50%;
  //border: 1px solid rgb(220, 220, 220);
  background-color: #f4f4f4;
`;

export const CenterDot = styled.div<{ isMobile: boolean }>`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 2px;
  height: 2px;
  background-color: grey;
  border-radius: 50%;
  transform: translate(-50%, -50%);
`;

export const DialLine = styled.div<{ rotation: number; isMobile: boolean }>`
  position: absolute;
  left: 50%;
  top: 0;
  width: 2px;
  height: ${({ isMobile }) => (isMobile ? "30px" : "16px")};
  background-color: grey;
  transform-origin: bottom;
  transform: translateX(-50%) rotate(${(props) => props.rotation}deg);
`;

export const DialPin = styled.div<{ x: number; y: number; isMobile: boolean }>`
  position: absolute;
  width: ${({ isMobile }) => (isMobile ? "8px" : "8px")};
  height: ${({ isMobile }) => (isMobile ? "8px" : "8px")};
  background-color: grey;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  left: ${(props) => `calc(50% + ${props.x}px)`};
  top: ${({ y, isMobile }) =>
    isMobile ? `calc(50% + ${y}px)` : `calc(50% + ${y}px)`};
`;

export const DoubleCol = styled.div`
  width: 100%;
  display: flex;
  gap: 10px;
  align-items: center;
  @media (min-width: 900px) {
    > div {
      width: 50%;
    }
  }
`;

export const ColWrapper = styled.div``;

export const MobileLeftWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const InputWrapper = styled.div`
  position: relative;
  @media (max-width: 900px) {
    width: 100%;
  }
`;

export const RotationIcon = styled.span`
  position: absolute;
  left: 15px;
  top: 8px;
  width: 20px;
  text-align: center;
  color: grey;
`;

export const HelpingIcon = styled.span`
  margin-left: 0.3125rem;
  color: grey;
  i {
    font-size: 14px;
  }
`;

export const RotationWheelWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 20px;
`;

export const AdjustWrapper = styled.div`
  display: flex;
  gap: 7.5px;

  align-items: center;
  justify-content: flex-end;
`;

export const RotationWheelText = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: grey;
  width: 130px;
`;

export const ResetButton = styled.button`
  width: 30px;
  padding: 0px;
  border: none;
  background: none;
  color: grey;
  i {
    font-size: 18px;
  }
`;
